import React, { useEffect, useState } from "react";
import "../../assets/styles/components/TableIndividualRacer.sass";

export const TableIndividualRacerEbike = (props) => {
  const { racers, racersDnf } = props;
  const [showRacers, setShowRacer] = useState([]);

  const transforArray = () => {
    const newArray = racersDnf.map((racer) => ({
      category_rank: "-",
      overall_rank: "-",
      categoria_es: racer.categoria_es,
      numero_corredor_1: racer.numero,
      nacionalidad_corredor_1_en: racer.nacionalidad,
      nombre_corredor_1: racer.nombre,
      tiempo: "n/a",
      diferencia: "n/a",
    }));
    return newArray;
  };

  useEffect(() => {
    const racersMerge = [...racers, ...transforArray()];

    const racersToShow = racersMerge.filter((racer) => racer.categoria_es === "E-BIKE");
    setShowRacer(racersToShow);
  }, [racers, racersDnf]);

  return (
    <div className="row">
      <div className="hidden-xs col-sm-12">
        <section className="table-results">
          <div className="table-results__title table-results__pos-category">CATEGORY POSITION</div>
          <div className="table-results__title table-results__pos-overall">GENERAL CLASSIFICATON</div>
          <div className="table-results__title table-results__category">CATEGORY</div>
          <div className="table-results__title table-results__number">RACE NUMBER</div>
          <div className="table-results__title table-results__racer">RACER NAME</div>
          <div className="table-results__title table-results__time">TEAM NAME</div>
          <div className="table-results__title table-results__time">OVERALL TIME</div>

          {showRacers.map((racer, i) => (
            <>
              <div className="table-results__pos-category racer__red">{racer.category_rank}</div>
              <div className="table-results__pos-overall">n/a</div>
              <div className="table-results__category">{racer.categoria_es}</div>
              <div className="table-results__number">
                <p>{racer.numero_corredor_1}</p>
              </div>
              <div className="table-results__racer">
                <p>
                  <img
                    src={`https://la-leyenda.com/2018/en/img/banderas/${racer.nacionalidad_corredor_1_en}.png`}
                    alt=""
                  />{" "}
                  {racer.nombre_corredor_1}
                </p>
              </div>
              <div className="table-results__time">
                <p>{racer.tiempo}</p>
              </div>
              <div className="table-results__dif racer__red">
                <p>{racer.diferencia}</p>
              </div>
            </>
          ))}
        </section>
      </div>
      <div className="visible-xs col-xs-12">
        <section className="table-results-mobile">
          {showRacers.map((racer, i) => (
            <div className="table-results-mobile__item" key={i}>
              <p>
                <b>Clasificación categoría:</b> {racer.category_rank}
              </p>
              <p>
                <b>Clasificación general:</b> {racer.overall_rank}
              </p>
              <p>
                <b>Categoría:</b> {racer.categoria_es}
              </p>
              <p>
                <b>Corredor:</b>
              </p>
              <span className="table-results-mobile__item--racer">
                {racer.numero_corredor_1}{" "}
                <img
                  src={`https://la-leyenda.com/2018/en/img/banderas/${racer.nacionalidad_corredor_1_en}.png`}
                  alt=""
                />{" "}
                {racer.nombre_corredor_1}
              </span>
              <p>
                <b>Tiempo total: </b>
                {racer.tiempo}
              </p>
              <p className="racer__red">
                <b>Tiempo diferencia: </b>
                {racer.diferencia}
              </p>
            </div>
          ))}
        </section>
      </div>
    </div>
  );
};
